import {
  createInjectionToken,
  createNoopInjectionToken,
} from 'ngxtension/create-injection-token';
import { ConektaCheckoutOptions } from './types';

export const [, provideConektaPublicKey, CONEKTA_PUBLIC_KEY] =
  createNoopInjectionToken<string>('Conekta Public Key');

export const [injectConektaConfig] = createInjectionToken(
  (publicKey: string) => ({
    publicKey,
    locale: 'es',
    conektaScriptUrl: 'https://pay.conekta.com/v1.0/js/conekta-checkout.min.js',
  }),
  {
    deps: [CONEKTA_PUBLIC_KEY],
  },
);

export const [
  injectConektaCurrentTheme,
  provideConektaCurrentTheme,
  CONEKTA_CURRENT_THEME,
] = createInjectionToken(() => {
  return 'light';
});

export const [injectConektaCheckoutThemes, , CONEKTA_CHECKOUT_THEMES] =
  createInjectionToken(
    (): Record<string, ConektaCheckoutOptions> => ({
      dark: {
        backgroundMode: 'darkMode',
        colorPrimary: '#F04B5F',
        colorText: '#F5F0FA',
        colorLabel: '#968796',
        inputType: 'flatMode',
        hideLogo: true,
      },
      light: {
        backgroundMode: 'lightMode',
        colorPrimary: '#E61536',
        colorText: '#291716',
        colorLabel: '#7E7576',
        inputType: 'flatMode',
        hideLogo: true,
      },
    }),
  );

export const [injectConektaCheckoutOptions] = createInjectionToken(
  (currentTheme, themes) => {
    return themes[currentTheme] ?? themes['light'];
  },
  {
    deps: [CONEKTA_CURRENT_THEME, CONEKTA_CHECKOUT_THEMES],
  },
);
